import {
  CarsOutlineGreenOnLightGreen,
  FlightsOutlineGreenOnLightGreen,
  HotelsOutlineGreenOnLightGreen,
} from '@pcln/brand'
import { Box, Flex, Image, Text, Truncate } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const ICON_SIZE = '32px'
const PRODUCT_IMAGE_HEIGHT = '48px'
const PRODUCT_IMAGE_WIDTH = '60px'
const PRODUCT_CODES = {
  FLIGHTS: 1,
  HOTELS: 5,
  CARS: 8,
}

const NoOverflowBox = styled(Box)`
  overflow: hidden;
`

function PackageRow({ id, brandLogo, image, product, starRating, subtitle, title }) {
  const imagePicker = () => {
    if (image) {
      if (product === PRODUCT_CODES.CARS) {
        return (
          <Flex
            alignItems='center'
            bg={id % 2 === 0 ? 'background.light' : 'background.lightest'}
            borderRadius='md'
            flexDirection='column'
            height={PRODUCT_IMAGE_HEIGHT}
            justifyContent='center'
            width={PRODUCT_IMAGE_WIDTH}
          >
            <Image alt='rc-image' borderRadius='md' src={image} />
            {brandLogo && <Image alt='rc-brand-image' borderRadius='md' height='24px' src={brandLogo} />}
          </Flex>
        )
      } else {
        return (
          <Flex
            alignItems='center'
            justifyContent='center'
            height={PRODUCT_IMAGE_HEIGHT}
            width={PRODUCT_IMAGE_WIDTH}
          >
            <Image
              alt={product === PRODUCT_CODES.FLIGHTS ? 'flight-image' : 'hotel-image'}
              borderRadius='md'
              src={image}
            />
          </Flex>
        )
      }
    } else {
      switch (product) {
        case PRODUCT_CODES.FLIGHTS:
          return (
            <Box data-testid='flights-icon' pt={1}>
              <FlightsOutlineGreenOnLightGreen size={ICON_SIZE} />
            </Box>
          )
        case PRODUCT_CODES.HOTELS:
          return (
            <Box data-testid='hotels-icon' pt={1}>
              <HotelsOutlineGreenOnLightGreen size={ICON_SIZE} />
            </Box>
          )
        case PRODUCT_CODES.CARS:
          return (
            <Box data-testid='cars-icon' pt={1}>
              <CarsOutlineGreenOnLightGreen size={ICON_SIZE} />
            </Box>
          )
      }
    }
  }

  const setImageBgColor = () => {
    if (image) {
      return null
    } else {
      return id % 2 === 0 ? 'background.light' : 'background.lightest'
    }
  }

  return (
    <Flex
      alignItems='center'
      bg={id % 2 === 1 ? 'background.light' : 'background.lightest'}
      borderRadius='md'
      height='76px'
    >
      <Flex
        alignItems='center'
        bg={setImageBgColor()}
        borderRadius='md'
        height={image ? PRODUCT_IMAGE_WIDTH : PRODUCT_IMAGE_HEIGHT}
        justifyContent='center'
        ml={2}
        px={image ? undefined : [2, null, null, 3]}
        width={PRODUCT_IMAGE_WIDTH}
      >
        {imagePicker()}
      </Flex>
      <NoOverflowBox ml={2} width='100%'>
        <Truncate textStyle='heading6'>{title}</Truncate>
        <Truncate color='text.light' fontSize={0}>
          {subtitle}
        </Truncate>
        {product === 5 && starRating && <Text textStyle='disclaimer'>{starRating}-Star HOTEL</Text>}
      </NoOverflowBox>
    </Flex>
  )
}

export default PackageRow
